import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

const NavContext = createContext(null);

export function NavProvider({ children }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  const refresh = useCallback(() => {
    return api
      .get("/nav")
      .then((r) => setItems(Array.isArray(r.data) ? r.data : []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const isVisible = (key) => {
    const item = items.find((i) => i.key === key);
    return item ? item.visible : true;
  };

  return <NavContext.Provider value={{ items, loading, isVisible, refresh }}>{children}</NavContext.Provider>;
}

export const useNav = () => useContext(NavContext);
